<div class="input-container">
  <label [for]="label">{{ label }}</label>
  <p-inputGroup [class.disabled]="disabled">
    <p-inputGroupAddon *ngIf="iconSrc">
      <img [src]="iconSrc" alt="icon" />
    </p-inputGroupAddon>
    <p-inputGroupAddon *ngIf="icon">
      <i [class]="icon"></i>
    </p-inputGroupAddon>
    <!-- Standard input for non-password fields -->
    <input
      [type]="type"
      [id]="label"
      [value]="value"
      (input)="onChange($any($event.target).value)"
      (blur)="onTouched()"
      pInputText
      [ngClass]="getValidationNgClasses(control)"
      [placeholder]="placeholder"
      *ngIf="type !== 'password'" />
    <!-- Password input with toggle visibility -->
    <ng-container *ngIf="type === 'password'">
      <input
        [type]="getPasswordFieldType()"
        [id]="label"
        [value]="value"
        (input)="onChange($any($event.target).value)"
        (blur)="onTouched()"
        pInputText
        [ngClass]="getValidationNgClasses(control)"
        [placeholder]="placeholder" />
      <p-inputGroupAddon>
        <i
          [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
          class="password-toggle-icon"
          (click)="togglePasswordVisibility()"></i>
      </p-inputGroupAddon>
    </ng-container>
  </p-inputGroup>
  @if (description) {
    <small class="input-description">{{ description }}</small>
  }
  @if (control?.invalid && (control?.dirty || control?.touched)) {
    <div class="error-messages">
      @for (message of errorMessages; track $index) {
        <small class="input-error-message">{{ message }}</small>
      }
    </div>
  }
</div>
